<template>
  <Popover ref="externalPopover" :showHeader="true" headerTitle="Externally Sourced Item">
    <div class="order-item-popover-content">
      <div v-if="purchaseOrder">
        <div class="font-weight-bold">Associated Purchase Order</div>
        <LinkPurchaseOrder :id="purchaseOrder.id" :name="purchaseOrder.sequenceNumber || 'Purchase Order'" />
        <div class="mb-2" />
        <div class="font-weight-bold" v-if="purchaseOrder.contact">Supplier</div>
        <LinkContact :id="purchaseOrder.contact.id" :name="purchaseOrder.contact.name" v-if="purchaseOrder.contact" />
      </div>
      <div v-else>
        No Purchase Order currently associated with this Item
      </div>
    </div>
  </Popover>
</template>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

export default {
  name: 'OrderItemExternalPopover',
  components: {
    Popover
  },
  props: {
    item: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    purchaseOrder() {
      if(!this.item || !this.item.purchaseOrder)
        return null
      return this.item.purchaseOrder
    }
  },
  methods: {
    displayFromElement(element) {
      this.$refs.externalPopover.displayFromElement(element)
    }
  }
}
</script>